export const APP_MANAGED_ROUTES = {
  LANDING_PAGE: '/',
  HOME: '/home',
  SIGN_IN: '/sign-in',
  SIGN_OUT: '/sign-out',
  SUPPORT: '/support',
};
